import * as tslib_1 from "tslib";
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => DimensionOptionCodeRawDto;
export class ARPaymentRawDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], ARPaymentRawDto.prototype, "documentDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], ARPaymentRawDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], ARPaymentRawDto.prototype, "dimensions", void 0);
export { ɵ0, ɵ1, ɵ2 };
